import { Box, Typography } from '@mui/material';
import React from 'react';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { Task } from '../../../types/Task';
import AppLink from '../../common/AppLink/AppLink';
import {
  tileContainerStyles,
  tileHeaderSectionStyles,
  textContainerStyles,
  textContainerSecondaryStyles,
  tileSectionLeftStyles,
  tileSectionRightStyles,
  tileHeaderLeftStyles,
  secondaryTextStyles,
  secondaryLabelStyles,
  secondaryIconStyles,
} from '../dashboardStyles';
import TaskDuePill from '../../tasks/TaskDuePill';
import _ from 'lodash';
import { AccountCircleOutlined, EventAvailable } from '@mui/icons-material';

interface ITaskTileProps {
  task: Task;
  currentEmployeeUuid?: string;
}

export function TaskTile({ task, currentEmployeeUuid }: ITaskTileProps) {
  let secondaryLink = null;
  if (task.event_uuid) {
    secondaryLink = {
      to: `/${ROUTE_PATHS.EVENTS}/${task.event_uuid}`,
      label: task.event_display_name,
    };
  } else if (task.account_uuid) {
    secondaryLink = {
      to: `/${ROUTE_PATHS.ACCOUNTS}/${task.account_uuid}`,
      label: task.account_display_name,
    };
  }

  const employeeText = task.employee_uuid === currentEmployeeUuid ? 'You' : task.employee_display_name;
  return (
    <Box key={task.uuid} sx={tileContainerStyles}>
      <Box sx={tileSectionLeftStyles}>
        <Box sx={tileHeaderSectionStyles}>
          <AppLink to={`/${ROUTE_PATHS.TASKS}/${task.uuid}`} sx={textContainerStyles}>
            <Typography title={task.name} sx={tileHeaderLeftStyles}>
              {task.name}
            </Typography>
          </AppLink>
        </Box>
        <Box sx={textContainerSecondaryStyles}>
          {secondaryLink && (
            <Box sx={secondaryTextStyles}>
              <EventAvailable sx={secondaryIconStyles} />
              <AppLink to={secondaryLink.to}>
                <Typography sx={secondaryLabelStyles}>{secondaryLink.label}</Typography>
              </AppLink>
            </Box>
          )}

          {task.employee_uuid && (
            <Box sx={secondaryTextStyles}>
              <AccountCircleOutlined sx={secondaryIconStyles} />
              <AppLink to={`/${ROUTE_PATHS.EMPLOYEES}/${task.employee_uuid}`}>
                <Typography sx={secondaryLabelStyles}>{employeeText}</Typography>
              </AppLink>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={tileSectionRightStyles}>
        <TaskDuePill title={_.startCase(task.status)} task={task} />
      </Box>
    </Box>
  );
}
